!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@campfire/field"), require("@material-ui/core"), require("@material-ui/core/useMediaQuery"), require("@material-ui/styles"), require("formik"), require("lodash"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "@campfire/field", "@material-ui/core", "@material-ui/core/useMediaQuery", "@material-ui/styles", "formik", "lodash", "react"], t) : t((e = e || self).select = {}, e.field, e.core, e.useMediaQuery, e.styles, e.formik, e.lodash, e.React);
}(this, function (e, t, r, n, a, i, l, o) {
  "use strict";

  n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;

  var c = "default" in o ? o.default : o,
      _u = function u() {
    return (_u = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);

      return e;
    }).apply(this, arguments);
  };

  function s(e, t) {
    var r = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var a = 0;

      for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    }

    return r;
  }

  var d = c.forwardRef(function (e, t) {
    var n = e.children,
        a = e.displayNative,
        i = s(e, ["children", "displayNative"]);
    return a ? c.createElement("option", _u({}, i), n) : c.createElement(r.MenuItem, _u({
      ref: t
    }, i), n || "");
  }),
      f = function f(e) {
    var n,
        a = e.items,
        i = e.singleItemBehaviour,
        l = e.valueFunction,
        o = e.renderFunction,
        f = e.label,
        m = e.field,
        p = e.includeEmpty,
        y = e.displayNative,
        v = e.variant,
        h = e.required,
        g = e.SelectProps,
        b = s(e, ["items", "singleItemBehaviour", "valueFunction", "renderFunction", "label", "field", "includeEmpty", "displayNative", "variant", "required", "SelectProps"]),
        E = _u(_u({}, m), {
      onChange: function onChange(e) {
        b.onChange && b.onChange(e), m.onChange(e);
      }
    });

    switch (v) {
      case "outlined":
        n = {
          variant: v
        };
        break;

      case "filled":
        n = {
          variant: "filled"
        };
        break;

      case "standard":
      default:
        n = {
          variant: "standard"
        };
    }

    return 1 === a.length && "lock" === i ? c.createElement(r.Box, {
      mt: "dense" === b.margin ? 1 : "normal" === b.margin ? 2 : 0,
      mb: "dense" === b.margin ? .5 : "normal" === b.margin ? 1 : 0
    }, f ? c.createElement(r.Typography, {
      color: "textSecondary",
      variant: "caption",
      display: "block",
      style: {
        marginTop: 4
      }
    }, f + ": ") : null, c.createElement(r.Typography, {
      color: "textSecondary"
    }, o(a[0]))) : 1 === a.length && "hide" === i ? null : c.createElement(t.Field, _u({
      select: !0,
      required: h
    }, n, {
      SelectProps: Object.assign(null != g ? g : {}, {
        native: y
      })
    }, b, {
      label: f
    }, E), p ? c.createElement(d, {
      displayNative: y,
      value: ""
    }) : null, a.map(function (e) {
      var t = l(e),
          r = {
        key: t,
        id: t,
        value: t
      };
      return c.createElement(d, _u({
        displayNative: y
      }, r), o(e));
    }));
  };

  e.Select = function (e) {
    var t = e.select,
        r = e.native,
        d = e.items,
        m = e.name,
        p = s(e, ["select", "native", "items", "name"]),
        y = a.useTheme();
    if (!y) throw new Error("DateField must be used inside of an MUI Theme Context");
    var v = !n(y.breakpoints.up("sm")),
        h = !0 === r || v && !1 !== r;
    if (!1 === t) throw new Error("Property 'select' cannot be false on the Select component, either set it to true or don't set it at all");
    var g = o.useState(d),
        b = g[0],
        E = g[1];
    return o.useEffect(function () {
      (d.length !== b.length || 0 !== d.length && !l.isEqual(d, b)) && E(d);
    }, [d]), c.createElement(c.Fragment, null, c.createElement(i.Field, _u({
      name: m,
      SelectProps: {
        native: h
      }
    }, p), function (t) {
      return c.createElement(f, _u({}, e, t, {
        items: b,
        displayNative: h,
        native: void 0
      }));
    }));
  }, e.SelectItem = d, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});